import $ from 'jquery';
import initTooltip from './initTooltipster';

export default function infoCardsFeatureTooltip() {

    const $infoCardsFeatureTooltip = $('.js-info-cards-feature-tooltip');

    const $options = {
        contentAsHTML: true,
        interactive: true,
        contentCloning: true,
        maxWidth: 314,
        side: 'top'
    };

    initTooltip($infoCardsFeatureTooltip, $options);
}
